module.exports = __webpack_public_path__ + "static/media/Tangrowth_gaussian2.7c501f84.png";